import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { Toaster } from "react-hot-toast"
import { Home } from "./pages/Home"
import { DonorProfile } from "./pages/DonorProfile"
import { NewRequest } from "./pages/NewRequest"
import { Requests } from "./pages/Requests"
import { RequestDetail } from "./pages/RequestDetail"
import { Ranking } from "./pages/Ranking"
import { RankingMunicipal } from "./pages/RankingMunicipal"
import { RankingEstadual } from "./pages/RankingEstadual"
import { RankingNacional } from "./pages/RankingNacional"
import { MapView } from "./pages/MapView"
import { ThankYou } from "./pages/ThankYou"
import { HemocentersPage } from "./pages/HemocentersPage"
import { Blog } from "./pages/Blog"
import { PrivacyPolicy } from "./pages/PrivacyPolicy"
import { TermsOfService } from "./pages/TermsOfService"
import { AdminDashboard } from "./pages/AdminDashboard"
import { About } from "./pages/About"
import { Dashboard } from "./pages/Dashboard"
import { ChatbotWidget } from "./components/ChatbotWidget"

function App() {
  return (
    <>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 5000,
          style: { background: '#363636', color: '#fff' },
          success: { style: { background: '#10b981' } },
          error: { style: { background: '#ef4444' } }
        }}
      />
      
      <ChatbotWidget />
      
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sou-doador" element={<DonorProfile />} />
          <Route path="/preciso-doar" element={<NewRequest />} />
          <Route path="/solicitacoes" element={<Requests />} />
          <Route path="/solicitacao/:requestId" element={<RequestDetail />} />
          <Route path="/ranking" element={<Ranking />} />
          <Route path="/ranking/municipal" element={<RankingMunicipal />} />
          <Route path="/ranking/estadual" element={<RankingEstadual />} />
          <Route path="/ranking/nacional" element={<RankingNacional />} />
          <Route path="/mapa" element={<MapView />} />
          <Route path="/hemocentros" element={<HemocentersPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/politica-privacidade" element={<PrivacyPolicy />} />
          <Route path="/termos-uso" element={<TermsOfService />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/sobre" element={<About />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/obrigado/:requestId" element={<ThankYou />} />
        </Routes>
      </Router>
    </>
  )
}

export default App
